import gql from 'graphql-tag';

export default gql`
  query GetAccountNftListByCreatorAccount($address: String, $creatorAddress: String, $limit: Int, $offset: Int) {
  current_token_ownerships_v2(
    where: {owner_address: {_eq: $address}, amount: {_gt: "0"}, current_token_data: {current_collection: {creator_address: {_eq: $creatorAddress}}}}
    limit: $limit
    offset: $offset
    order_by: {current_token_data: {token_name: asc}}
  ) {
    amount
    current_token_data {
      token_name
      supply
    }
  }
}
`;
